// extracted by mini-css-extract-plugin
export default {"employerActionsBtnContainer":"EmployerTakeActionsBtn_employerActionsBtnContainer__VqgNT","employerButton":"EmployerTakeActionsBtn_employerButton__yUgbA"};